import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EventSourcePolyfill, OnMessageEvent } from 'ng-event-source';
import { SessionQuery } from '../state/session';


@Injectable({
	providedIn: 'root'
})
export class SseClientService {


	constructor(
		private readonly sessionQuery: SessionQuery
	) {

	}

	public request<T>(url: string): Promise<T> {
		return new Promise<T>((resolve, reject) => {
			if (!url) return reject('URL is required to create an SSE request');

			const fullUrl = url.startsWith('/') ? `${environment.apiUrl}${url}` : url;
			const eventSource = new EventSourcePolyfill(fullUrl, {
				headers: {Authorization: `Bearer ${this.sessionQuery.getToken()}`}
			});

			eventSource.onmessage = (event: OnMessageEvent) => {
				const response = JSON.parse(event.data);
				if (!response.hasMore) {
					eventSource.close();
					resolve(response.data);
				}
			};

			eventSource.onerror = (event: OnMessageEvent) => {
				eventSource.close();
				reject(eventSource.readyState === eventSource.CLOSED
					? 'EventSource closed unexpectedly'
					: event);
			};
		});
	}
}
